const SocketHost = "https://nikahemuslim.com";
// const SocketHost = "http://localhost:8000";
export default SocketHost;
